import { nowIsoAndUnix } from "@@/shared/date-time/iso-and-unix";
import { orderItemZodSchema } from "@@/shared/orders/order-items/order-item";
import { systemUserZodSchema } from "@@/shared/users/system-user";
import { userIdZodSchema } from "@@/shared/users/user-id";
import z from "zod";
import { orderChangeIdFactory } from "./_order-change-id";
import { orderChangeSchemaFactory } from "./_order-change.schema-factory";

const orderItemRemovedOrderChangeDataZodObject = z.object({
    removedBy: userIdZodSchema.or(systemUserZodSchema),
    orderItem: orderItemZodSchema,
    type: z.literal("ORDER_ITEM_REMOVED"),
});

const orderItemRemovedOrderChangeZodObject = orderChangeSchemaFactory(
    "ORDER_ITEM_REMOVED",
    orderItemRemovedOrderChangeDataZodObject,
);

type OrderItemRemovedOrderChange = z.infer<
    typeof orderItemRemovedOrderChangeZodObject
>;

const _factoryParamsZodObject = orderItemRemovedOrderChangeZodObject.omit({
    _id: true,
    _createdAt: true,
    _type: true,
    type: true,
});
type FactoryParams = z.infer<typeof _factoryParamsZodObject>;
const orderItemRemovedOrderChangeFactory = (
    params: FactoryParams,
): OrderItemRemovedOrderChange => {
    const orderChange: OrderItemRemovedOrderChange = {
        ...params,
        _id: orderChangeIdFactory(),
        _createdAt: nowIsoAndUnix(),
        _type: "ORDER_CHANGE",
        type: "ORDER_ITEM_REMOVED",
    };
    return orderChange;
};

const isOrderItemRemovedOrderChange = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    orderChange: any,
): orderChange is OrderItemRemovedOrderChange => {
    return (
        orderChange._type === "ORDER_CHANGE" &&
        orderChange.type === "ORDER_ITEM_REMOVED"
    );
};

export {
    isOrderItemRemovedOrderChange,
    orderItemRemovedOrderChangeFactory,
    orderItemRemovedOrderChangeZodObject,
};
export type { OrderItemRemovedOrderChange };
